import type { AIPromptActionPluginState, PromptAction } from './states';
import { ACTIONS } from './states';

/**
 * Reduces the plugin state based on the given action
 */
export function reducer(
	state: AIPromptActionPluginState,
	action: PromptAction,
): AIPromptActionPluginState {
	switch (action.type) {
		case ACTIONS.ACTION_COMPLETED:
			return {
				...state,
				actionSource: action.data.actionSource,
				actionType: action.data.actionType,
				prompt: action.data.prompt,
			};
		case ACTIONS.CLEAR_ACTION_COMPLETED:
			return {
				...state,
				actionSource: undefined,
				actionType: undefined,
				prompt: undefined,
			};
		default:
			return state;
	}
}
